"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pclnDesignSystem = require("pcln-design-system");

var _Caption = _interopRequireDefault(require("../../../text/Caption"));

var _Heading = _interopRequireDefault(require("../../../text/Heading6"));

var _HotelRating = _interopRequireDefault(require("../HotelRating"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function GuestRating(_ref) {
  var title = _ref.title,
      rating = _ref.rating,
      ratingMax = _ref.ratingMax,
      useStars = _ref.useStars,
      reviewQuantity = _ref.reviewQuantity,
      color = _ref.color,
      onClick = _ref.onClick,
      titleSmall = _ref.titleSmall;
  var reviewsText = reviewQuantity > 1 ? 'Reviews' : 'Review';
  var flexDirection = onClick ? 'column' : 'row';
  var reviewCountText = onClick ? "".concat(reviewQuantity, " ").concat(reviewsText) : "(".concat(reviewQuantity, " ").concat(reviewsText, ")");
  var reviewCountProps = onClick ? {
    mt: 1
  } : {
    ml: 1
  };
  var titleStyle = titleSmall ? _react["default"].createElement(_pclnDesignSystem.Text, {
    fontWeight: "600",
    fontSize: 0,
    mb: 1
  }, title) : _react["default"].createElement(_Heading["default"], {
    mb: 1
  }, title);
  return Boolean(rating) && _react["default"].createElement("div", null, titleStyle, _react["default"].createElement(_pclnDesignSystem.Flex, {
    flexDirection: flexDirection
  }, _react["default"].createElement(_HotelRating["default"], {
    useStars: useStars,
    rating: rating,
    ratingMax: ratingMax,
    color: color
  }), reviewQuantity > 0 && _react["default"].createElement(_Caption["default"], _extends({
    color: color,
    onClick: onClick
  }, reviewCountProps), reviewCountText)));
}

GuestRating.displayName = 'GuestRating';
GuestRating.propTypes = {
  title: _propTypes["default"].string,
  rating: _propTypes["default"].number,
  ratingMax: _propTypes["default"].number,
  useStars: _propTypes["default"].bool,
  reviewQuantity: _propTypes["default"].number,
  color: _propTypes["default"].string,
  titleColor: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  titleSmall: _propTypes["default"].bool
};
GuestRating.defaultProps = {
  title: '',
  ratingMax: 5,
  useStars: false,
  reviewQuantity: 0,
  color: 'primary',
  titleSmall: false
};

var _default = (0, _react.memo)(GuestRating);

exports["default"] = _default;